module.exports = __webpack_public_path__ + "img/resources-header.d20dc14a.jpg";